import React from "react";
import { IGiftFinderQuestionOption } from "@types";

const DEFAULT_MULTI_SELECT_LIMIT = Infinity;

interface Props {
    options: IGiftFinderQuestionOption[];
    value: any[];
    onChange: (value: any[]) => void;
    multiSelectLimit?: number;
}

const MultiSelection: React.FC<Props> = ({
    options,
    value,
    onChange,
    multiSelectLimit = DEFAULT_MULTI_SELECT_LIMIT,
}) => {
    const selected = Array.isArray(value) ? value : [];
    const maxSelections = Math.max(1, multiSelectLimit);
    const atLimit = selected.length >= maxSelections;

    const onToggle = (id: number) => {
        if (selected.includes(id)) {
            onChange(selected.filter((item) => item !== id));
            return;
        }
        if (selected.length >= maxSelections) {
            return;
        }
        onChange([...selected, id]);
    };

    return (
        <div className="flex flex-col gap-3">
            {options.map((option) => {
                const isSelected = selected.includes(option.id);
                const isDisabled = !isSelected && atLimit;
                return (
                    <button
                        key={option.id}
                        type="button"
                        disabled={isDisabled}
                        aria-pressed={isSelected}
                        aria-label={`gift-finder-multi-option-${option.id}`}
                        onClick={() => onToggle(option.id)}
                        className={`w-full p-4 rounded-xl border flex items-center gap-3 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none ${
                            isSelected
                                ? "border-button-primary bg-[#008AF60D]"
                                : "border-gray-200 hover:border-button-primary"
                        }`}
                    >
                        <span
                            className={`w-5 h-5 rounded border flex items-center justify-center text-xs ${
                                isSelected
                                    ? "border-button-primary bg-button-primary text-white"
                                    : "border-gray-300 text-transparent"
                            }`}
                        >
                            ✓
                        </span>
                        <span
                            className={`text-sm ${
                                isSelected ? "text-button-primary font-semibold" : "text-[#4F2F18]"
                            }`}
                        >
                            {option.option_data}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default React.memo(MultiSelection);
